import { render, staticRenderFns } from "./journal-detail.vue?vue&type=template&id=56db5369"
import script from "./journal-detail.vue?vue&type=script&lang=js"
export * from "./journal-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports